import React from 'react'
import "./BlogPost.css";

import ease from "../../Assets/b70/ease.jpg"

function Blog70() {
    return (
        <div className='container-fluid my-5'>
            <div className='row mb-5'>
                <div className='col blog-text text-center'>
                    <h1>Streamline Your Medical Records with MedEase.</h1>
                    <h6>March 04, 2026 at 06:00 PM</h6>
                </div>
            </div>

            <div className='row align-items-center justify-content-center mx-5 gx-5 gy-5'>
                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-5 col-xxl-5'>
                    <img src={ease} className="blog-img" alt="..." />
                </div>
                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 blog-text'>
                    <p>Managing patient information has never been simpler. MedEase by MYT Solutions is designed to help healthcare providers organize their clinical data with ease and security. Our centralized system removes the stress of paperwork, so you can focus on providing quality care.</p>
                    <p>•   𝗖𝗲𝗻𝘁𝗿𝗮𝗹𝗶𝘇𝗲𝗱 𝗗𝗮𝘁𝗮: Store, access, and update all patient records in one secure place.
                       •   𝗥𝗲𝗮𝗹-𝗧𝗶𝗺𝗲 𝗔𝗰𝗰𝗲𝘀𝘀: Check patient history, treatments, and lab results anytime, whether in the clinic or outside.
                       •   𝗦𝘁𝗿𝗼𝗻𝗴 𝗦𝗲𝗰𝘂𝗿𝗶𝘁𝘆: Protect sensitive patient information with reliable security and privacy standards.
                       •   𝗦𝗺𝗮𝗿𝘁 𝗦𝗲𝗮𝗿𝗰𝗵: Quickly find the records you need using easy search and filter tools.
                        Choose a smarter and simpler way to manage medical records with MedEase.</p>
                    <p><a href='https://www.facebook.com/hashtag/mytsoftdevsolutions' target='_blank' className='blog-link'>
                        #MYTSoftDevSolutions</a>
                        <a href='https://www.facebook.com/hashtag/techforgood' target='_blank' className='blog-link'>
                        #TechForGood</a>
                        <a href='https://www.facebook.com/hashtag/builttolast' target='_blank' className='blog-link'>
                        #BuildToLast</a>
                        <a href='https://www.facebook.com/hashtag/medeasebymyt' target='_blank' className='blog-link'>
                        #MedEaseByMyt</a>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Blog70;
